import consumerApi from "api/services/consumer-api";
import { tryUseImgix } from "@leafly-com/frontend-components";

export const mapMenuItemImages = (menuItem: any) => {
  return {
    ...menuItem,
    imageUrl: tryUseImgix(menuItem.imageUrl),
    thumbnailUrl:
      tryUseImgix(menuItem.formattedThumbnailUrl) ||
      tryUseImgix(menuItem.imageUrl),
  };
};

const getMenuItem = async (menuItemId: number, countryCode?: string) => {
  try {
    const { data } = await consumerApi.get<any>(
      `/api/variants/v1/${menuItemId}`,
      {
        headers: {
          "x-country-code": countryCode || "US",
        },
      }
    );

    return mapMenuItemImages(data);
  } catch (err) {
    if (err.response.status === 404) {
      return {
        is404: true,
      };
    }

    return {
      hasCriticalError: true,
    };
  }
};

export default getMenuItem;
